import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { TasaImpuestosComponent } from "./components/impuestos";
import { ConfiguracionEmpresa, validar as validarEmpresa } from "./components/configuracionempresa";
import { ConfiguracionCorreo, validar as validarCorreo } from "./components/configuracioncorreo";

import { ColoniaComponent } from "app/features/componentes/index";

import { CuentasComponent, validar as validarCuentas } from "./components/contabilidad";
import { ConfigSistemaContabilidad, validar as validarSistemaConta } from "./components/contabilidad/configsistema";
import { PopupModal } from "../../diseño/items/popupmodal";

type Entity = models.ConfigSistemaDTO;

const resource = resources.MatrizTarifa;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGuardar: () => Promise<void>;
}

function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        IdTarifa: validation.required,
        ConfiguracionEmpresa: validation.subrule(validarEmpresa),
        ConfiguracionCorreo: validation.subrule(validarCorreo),

        Contabilidad: validation.subrule(validarCuentas),

        RfcReceptorFacturaPublicoGeneral: validation.required,
        IdArticuloConceptoDeNotaDeCredito: validation.required,
        IdProductoSATConceptoNotaCredito: validation.required,
        IdUnidadSATConceptoNotaCredito: validation.required,

    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class ConfigSistemaFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));
    modals = kea.createModalManager();

    private setImagenInicio = (datos: string | null) => {
        const viejo = this.props.value;
        const next: Entity = {
            ...viejo,
            ModificoImagenInicio: true,
            ImagenInicio: datos
        };

        if (this.props.onChange) {
            this.props.onChange(next);
        }
    }

    private handleOnAgrergarImagenInicio = async () => {
        const archivo = await kea.upload();
        if (archivo) {
            const datos = await kea.blobToBase64(archivo);
            this.setImagenInicio(datos);
        }
    }

    private handleOnQuitarImagenInicio = async () => {
        this.setImagenInicio(null);
    }

    private handleOnMostrarImagenInicio = async () => {
        const data = this.props.value.ImagenInicio;
        if (data != null) {
            const blob = kea.base64ToBlob(data);
            const result = this.modals.showModal(PopupModal, { image: blob }, undefined);
        }
    }

    private handleOnAgregarApk = async () => {
        const archivo = await kea.upload();
        if (archivo) {
            var aceptedExtensions = ["apk"];
            const name = archivo.name;
            var nombre = archivo.name.split(".");
            var extension = nombre[nombre.length - 1].toLowerCase();
            if (aceptedExtensions.indexOf(extension) != -1) {
                const datos = await kea.blobToBase64(archivo);
                const tipo = archivo.type;
                const viejo = this.props.value;
                var cambio: Partial<Entity> = { Apk: datos, NombreApkConExtension: name, ModificoAPK: true };
                if (this.props.onChange)
                    await this.props.onChange({ ...viejo, ...cambio });
            } else {
                await kea.message("Solo se aceptan archivos .apk");
            }
        }
    }

    private onDeleteApk = async () => {
        const viejo = this.props.value;
        var cambio: Partial<Entity> = { Apk: "", NombreApkConExtension: "", ModificoAPK: true };
        await this.props.onChange({ ...viejo, ...cambio });
    }

    private handleOnDescargarApk = async () => {
        if (await kea.yesno("¿Descargar archivo .apk?")) {
            const apk = await resources.ConfigSistema.GetApk();
            var config = this.props.value;
            kea.download(kea.base64ToBlob(apk, 'application/vnd.android.package-archive'), config.NombreApkConExtension);
        }
    }

    private handleOnCambiarMatrizTarifas = async () => {
        if (await kea.yesno("¿Actualizar matriz de tarifas?")) {
            
            const func = resource.ActualizarPreciosMatriz
            var val = this.props.value;

            //debugger
            if( val.IdMatrizTarifa === undefined || val.IdMatrizTarifa === null  )
            { val.IdMatrizTarifa = 0 }
            
            var res = await func(val.ActualizarMatriz_Cantidad, val.ActualizarMatriz_Seguro, Boolean (val.ActualizarMatriz_Aumento), val.IdMatrizTarifa )
            
            await kea.message("Matriz de tarifas actualizadas", undefined, "success");
        }
    }

    nombreProps = (x: Props) => x.value.NombreApkConExtension;
    nombreApk = createSelectorRx(this.nombreProps, nombre => nombre ? nombre.length < 20 ? nombre : nombre.substr(0, 15) + " ... .apk" : "")

    private handleOnAgregarAviso = async () => {
        const archivo = await kea.upload();
        if (archivo) {
            var aceptedExtensions = ["pdf"];
            const name = archivo.name;
            var nombre = archivo.name.split(".");
            var extension = nombre[nombre.length - 1].toLowerCase();
            if (aceptedExtensions.indexOf(extension) != -1) {
                const datos = await kea.blobToBase64(archivo);
                const tipo = archivo.type;
                const viejo = this.props.value;
                var cambio: Partial<Entity> = { Aviso: datos, ModificoAviso: true };
                if (this.props.onChange)
                    await this.props.onChange({ ...viejo, ...cambio });
            } else {
                await kea.message("Solo se aceptan archivos .pdf");
            }
        }
    }

    private onDeleteAviso = async () => {
        const viejo = this.props.value;
        var cambio: Partial<Entity> = { Aviso: "", ModificoAviso: true };
        await this.props.onChange({ ...viejo, ...cambio });
    }

    private handleOnDescargarAviso = async () => {
        if (await kea.yesno("¿Descargar archivo pdf?")) {
            const aviso = await resources.ConfigSistema.GetAviso();
            kea.download(kea.base64ToBlob(aviso, 'application/pdf'), "AVISO DE PRIVACIDAD.pdf");
        }
    }

    private handleOnAgregarFile = async (x: keyof Entity) => {
        const archivo = await kea.upload();
        if (archivo) {
            var aceptedExtensions = x == "LlaveModoPruebas" ? ["key"] : ["cer"];
            var keyOfNombre: keyof Entity = x == "LlaveModoPruebas" ? "NombreLlaveConExtensionModoPruebas" : "NombreCertificadoConExtensionModoPruebas";
            const name = archivo.name;
            var nombre = archivo.name.split(".");
            var extension = nombre[nombre.length - 1].toLowerCase();
            if (aceptedExtensions.indexOf(extension) != -1) {
                const datos = await kea.blobToBase64(archivo);
                const tipo = archivo.type;
                const viejo = this.props.value;
                var cambio: Partial<Entity> = { [x]: datos, [keyOfNombre]: name };
                if (this.props.onChange)
                    await this.props.onChange({ ...viejo, ...cambio });
            } else {
                await kea.message("Solo se aceptan archivos .key");
                this.setState({ imagen: "" });
            }
        }
    }

    nombreLLave = (x: Props) => (x.value.NombreLlaveConExtensionModoPruebas ? x.value.NombreLlaveConExtensionModoPruebas.length : 0) < 20 ? x.value.NombreLlaveConExtensionModoPruebas || "" : x.value.NombreLlaveConExtensionModoPruebas.substr(0, 15) + "... .key";
    nombreCertificado = (x: Props) => (x.value.NombreCertificadoConExtensionModoPruebas ? x.value.NombreCertificadoConExtensionModoPruebas.length : 0) < 20 ? x.value.NombreCertificadoConExtensionModoPruebas || "" : x.value.NombreCertificadoConExtensionModoPruebas.substr(0, 15) + "... .cer";
    nombreCertificadoCompleto = (x: Props) => x.value.NombreCertificadoConExtensionModoPruebas || "";
    nombreLLaveCompleto = (x: Props) => x.value.NombreLlaveConExtensionModoPruebas || "";

    private handleOnDescargarFile = async (x: keyof Entity) => {
        const mensaje = x == "LlaveModoPruebas" ? ".key" : ".cer"
        if (await kea.yesno("¿Descargar archivo " + mensaje + "?")) {
            var value = this.props.value;
            var keyOfNombre: keyof Entity = x == "LlaveModoPruebas" ? "NombreLlaveConExtensionModoPruebas" : "NombreCertificadoConExtensionModoPruebas";
            kea.download(kea.base64ToBlob(value[x] as string, 'application/pkix-cert'), value[keyOfNombre]);
        }
    }

    private onDeleteFile = async (x: keyof Entity) => {
        const mensaje = x == "LlaveModoPruebas" ? ".key" : ".cer"
        if (await kea.yesno("Eliminar archivo " + mensaje + "?")) {
            var keyOfNombre: keyof Entity = x == "LlaveModoPruebas" ? "NombreLlaveConExtensionModoPruebas" : "NombreCertificadoConExtensionModoPruebas";
            const viejo = this.props.value;
            var cambio: Partial<Entity> = { [x]: "", [keyOfNombre]: "" };
            await this.props.onChange({ ...viejo, ...cambio });
        }
    }

    render() {
        const { value, onGuardar } = this.props;
        const getField = this.getField;
        const hasError = this.hasError(this.props);
        const Tarifa = getField(selectores.Tarifa);
        const Number = getField(kea.Number);
        const Text = getField(kea.Text);
        const Articulo = getField(selectores.Articulo);
        const ContenidoSobre = getField(selectores.ContenidoSobre);
        const Colonia = getField(ColoniaComponent);
        const Tasas = getField(TasaImpuestosComponent);
        const ConfigEmp = getField(ConfiguracionEmpresa);
        const Cuentas = getField(CuentasComponent);
        const SistemaConta = getField(ConfigSistemaContabilidad);
        const Correo = getField(ConfiguracionCorreo);
        const FormaPagoSAT = getField(selectores.ClaveFormaPagoSat);
        const MetodoPagoSAT = getField(selectores.ClaveMetodoPagoSat);
        const UnidadSAT = getField(selectores.ClaveUnidadSat);
        const ProductoSAT = getField(selectores.ClaveProductoSat);
        const Clientes = getField(selectores.Cliente);
        const Regimen = getField(selectores.ClaveRegimenFiscalSat);


        const MatrizTarifa = getField(selectores.MatrizTarifa);


        const SiNo = getField(selectores.SiNo);
        const AumentoDisminucion = getField(selectores.AumentoDisminucion);

        const nombreCertificado = this.nombreCertificado(this.props);
        const nombreLLave = this.nombreLLave(this.props);
        const nombreCertificadoCompleto = this.nombreCertificadoCompleto(this.props);
        const nombreLLaveCompleto = this.nombreLLaveCompleto(this.props);
        
        const nombreApk = this.nombreApk(this.props);

        let CambiarMatrizTarifa = true;

        return (
            <div>
                <kea.Title titulo="Configuración del sistema Paqueteria" onRegresar={() => history.go("/login")} />

                <kea.Title titulo="General" size="h4" />

                {kea.autogrid(3, [
                    <Tarifa field="IdTarifa" label="Tarifa / convenio general" />,
                    <Number field="DivisorPesoVolumetrico" label="Divisor del peso volumétrico" />,
                    <Articulo field="IdArticuloGuia" label="Articulo guia" />,
                    <Articulo field="IdArticuloGuiaPP" label="Articulo guia PP" />,
                    <Articulo field="IdArticuloConceptoDeNotaDeCredito" label="Articulo para conceptos de las notas de crédito" />,
                    <Articulo field="IdArticuloConceptoDeREP" label="Articulo para conceptos de las REP" />,
                    <ContenidoSobre field="IdContenidoSobreAcuse" label="Contenido sobre acuse" />,
                    <Number field="LimiteInactividad" label="Limite de tiempo de inactividad de los usuarios (segundos)" />,
                    <SiNo field="EsDePruebas" label="¿Es de pruebas?" />,
                    <Text field="Dominio" label="Dominio del sistema" />,
                    <Number field="IdGuiaLimiteStatus" label="Id de guía limite para views" />,
                    <Number field="ImporteGastoAdministrativo" label="Importe de gasto administrativo por guias" />,
                    <SiNo field="HabilitarValidacionesCartaPorte" label="¿Habilitar Validaciones Carta Porte?" />,
                    <SiNo field="HabilitarTimbradoCartaPorte" label="¿Habilitar timbrado de factura con Carta Porte?" />,
                    <Clientes field="IdClienteConfigPaqueteria" label="Cliente default para paqueteria"  />,

                    <span>
                        <kea.Button style="success" onClick={this.handleOnAgregarApk}  >Agregar .apk </kea.Button>
                        <kea.Link style="link" onClick={this.handleOnDescargarApk}>
                            {nombreApk}
                        </kea.Link>
                        <kea.IconButton iconClass={fa("trash-o")} style="danger" onClick={this.onDeleteApk} tooltip="eliminar .apk" />
                    </span>,
                    <span>
                        <kea.Button style="success" onClick={this.handleOnAgregarAviso}  >Agregar aviso de privacidad </kea.Button>
                        <kea.Link style="link" onClick={this.handleOnDescargarAviso}>
                            Aviso de privacidad.pdf
                        </kea.Link>
                        <kea.IconButton iconClass={fa("trash-o")} style="danger" onClick={this.onDeleteAviso} tooltip="eliminar aviso privacidad" />
                    </span>,
                    <span>
                        <kea.Button style="success" onClick={this.handleOnAgrergarImagenInicio}>Agregar imagen de inicio</kea.Button>
                        {
                            this.props.value.ImagenInicio &&
                            <kea.Link style="link" onClick={this.handleOnMostrarImagenInicio}>
                                Mostrar popup
                            </kea.Link>
                        }
                        <kea.IconButton iconClass={fa("trash-o")} style="danger" onClick={this.handleOnQuitarImagenInicio} tooltip="Quitar imagen" />
                    </span>
                ])}

                <div>
                <kea.Title titulo="Cambios a matriz de tarifas" size="h4" />
                {kea.autogrid(3, [
                    <Number field="ActualizarMatriz_Cantidad" label="Porcentaje del cambio" format="percentage"  />,
                    <Number field="ActualizarMatriz_Seguro" label="Porcentaje del seguro" format="percentage" />,
                    <AumentoDisminucion field="ActualizarMatriz_Aumento" label="Tipo de cambio" />,
                    <MatrizTarifa field="IdMatrizTarifa" label="MatrizTarifa" />,
                    <kea.GuardarButton onClick={this.handleOnCambiarMatrizTarifas} />
                ])}
                </div>

                <kea.Title titulo="Comisíón vendedores" size="h4" />
                {kea.autogrid(3, [
                    <Number field="TiempoMantenimiento" label="Tiempo  de mantenimiento de cliente en meses" />,
                    <Number field="FactorTiempoMantenimiento" label="Factor de tiempo mantenimiento" format="percentage" />,
                    <Number field="FactorMaximoDescuento" label="Factor máximo de descuento" format="percentage" />,
                    <Number field="ComisionDescuentoSuperaFactor" label="Comisión si descuento supera factor máximo" format="percentage" />,
                    <Number field="ComisionDescuentoNoSuperaFactor" label="Comision si descuento no supera factor máximo" format="percentage" />,
                ])}


                <kea.Title titulo="Claves SAT" size="h4" />
                {kea.autogrid(3, [
                    <Text field="RfcReceptorFacturaPublicoGeneral" label="RFC receptor de factura de público general" />,
                    <ProductoSAT field="IdProductoSATConceptoNotaCredito" label="Clave de producto para conceptos de nota de crédito" />,
                    <ProductoSAT field="IdProductoSATConceptoREP" label="Clave de producto para conceptos de REP" />,
                    <UnidadSAT field="IdUnidadSATConceptoNotaCredito" label="Unidad para conceptos de nota de crédito" />,
                    <UnidadSAT field="IdUnidadSATConceptoREP" label="Unidad para conceptos de REP" />,
                ])}

                <kea.Title titulo="Datos de la empresa" size="h4" />

                <Colonia field="IdColonia" label="Dirección de la empresa:" />

                <ConfigEmp field="ConfiguracionEmpresa" />
                <Correo field="ConfiguracionCorreo" label="Configuración de correo de facturación" />
                <Correo field="ConfiguracionCorreoGuias" label="Configuración de correo de guías" />
                <Cuentas field="Contabilidad" label="Cuentas contables" />
                <SistemaConta field="ConexionContabilidad" label="Conexión con sistema de contabilidad" />

                {/*<Text field="CondicionesGeneralesContrato" label="Condiciones generales del contrato" />*/}
                <kea.Panel title={"Timbrado modo pruebas"}>
                    {kea.autogrid(3, [
                        <Text field="NombreEmisorModoPruebas" label="Nombre del emisor modo pruebas:" />,
                        <Text field="RfcModoPruebas" label="RFC de emisor modo pruebas:" />,
                        <Regimen field="ClaveSatRegimenFiscalEmisorModoPruebas" label="Regimen fiscal modo pruebas:" />,
                        <Text field="CodigoPostalModoPruebas" label="Codigo postalmodo pruebas:" />,

                        <Text field="ContraseñaLlaveModoPruebas" label="Contraseña  SAT:"  />,
                        <span>
                            {
                                <span>
                                    <kea.Button style="success" onClick={() => this.handleOnAgregarFile("LlaveModoPruebas")}   >Agregar .key </kea.Button>
                                    <kea.Link style="link" tooltip={nombreLLaveCompleto} onClick={() => this.handleOnDescargarFile("LlaveModoPruebas")}>
                                        {nombreLLave}
                                    </kea.Link>
                                    <kea.IconButton iconClass={fa("trash-o")} style="danger" onClick={() => this.onDeleteFile("LlaveModoPruebas")} tooltip="eliminar .key" />
                                </span>
                            }
                        </span>,
                        <span>
                            {
                                <span>
                                    <kea.Button style="success" onClick={() => this.handleOnAgregarFile("CertificadoModoPruebas")} >Agregar .cer </kea.Button>
                                    <kea.Link style="link" tooltip={nombreCertificadoCompleto} onClick={() => this.handleOnDescargarFile("CertificadoModoPruebas")}>
                                        {nombreCertificado}
                                    </kea.Link>
                                    <kea.IconButton iconClass={fa("trash-o")} style="danger" onClick={() => this.onDeleteFile("CertificadoModoPruebas")} tooltip="eliminar .cer" />
                                </span>
                            }
                        </span>
                    ])}
                </kea.Panel>
                
                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>

                {this.modals.component}
            </div>);
    }
}

export const ConfigSistemaForm = componentToRx(ConfigSistemaFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/configuraciones/edit/form.tsx